import { render, staticRenderFns } from "./QuestionList_bank.vue?vue&type=template&id=0bbc60a9"
import script from "./QuestionList_bank.vue?vue&type=script&lang=js"
export * from "./QuestionList_bank.vue?vue&type=script&lang=js"
import style0 from "./QuestionList_bank.vue?vue&type=style&index=0&id=0bbc60a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports